import Response from '../base/Response';

export default class NotFoundResponse extends Response {

}
